import React from "react";

const SignOut = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7142 5.14397V3.37072C11.7142 3.10208 11.665 2.83637 11.5697 2.59038C11.4744 2.34438 11.3351 2.12346 11.1607 1.94156C10.9862 1.75967 10.7803 1.62076 10.556 1.53362C10.3317 1.44647 10.0939 1.41299 9.85761 1.43529L3.00047 2.08205C2.57194 2.12249 2.17247 2.34391 1.8813 2.70241C1.59012 3.06091 1.42849 3.53029 1.42847 4.01748V15.9816C1.42849 16.4688 1.59012 16.9382 1.8813 17.2967C2.17247 17.6552 2.57194 17.8766 3.00047 17.917L9.85761 18.5647C10.094 18.587 10.3318 18.5535 10.5562 18.4663C10.7805 18.3791 10.9865 18.2401 11.161 18.0581C11.3355 17.8761 11.4747 17.6551 11.57 17.409C11.6652 17.1629 11.7143 16.8971 11.7142 16.6283V14.8551M10.857 9.99953H18.5713H10.857ZM18.5713 9.99953L15.7145 6.11508L18.5713 9.99953ZM18.5713 9.99953L15.7145 13.884L18.5713 9.99953Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SignOut;
